'use client';

import {
  ArrowRight,
  BeerStein,
  BowlSteam,
  Champagne,
  Hamburger,
  IntersectThree,
  Popcorn,
} from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import Link from 'next/link';
import type { ReactElement } from 'react';

import Title from '@/components/common/Title';

interface BusinessProp {
  title: string;
  desc: string;
  icon: ReactElement;
  url: string;
  bgColor: string;
  textColor: string;
  borderColor: string;
}

const businessTypes: BusinessProp[] = [
  {
    title: 'Quán ăn truyền thống',
    // desc: 'Đơn hàng được đồng bộ chính xác, giảm thiểu sai sót trong vận hành',
    desc: 'Hệ thống quản lý bán hàng thông minh thay thế phương pháp ghi chép truyền thống tốn thời gian và dễ mắc sai sót, giúp ghi nhận order nhanh chóng và chính xác.',
    icon: <BowlSteam size={32} weight="duotone" />,
    url: '/',
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-600',
    borderColor: 'group-hover:border-amber-200',
  },
  {
    title: 'Quán lẩu - nhậu',
    // desc: 'QR Gọi món - tăng trải nghiệm của khách hàng và nâng tầm thương hiệu',
    desc: 'Tích hợp QR gọi món cùng quản lý bàn ăn và đồng bộ thời gian thực giữa khách, nhân viên và bếp, nâng cao hiệu suất vận hành; tính năng gọi nhân viên chỉ với một chạm giúp phục vụ nhanh gọn và chính xác.',
    icon: <BeerStein size={32} weight="duotone" />,
    url: '/',
    bgColor: 'bg-green-50',
    textColor: 'text-green-600',
    borderColor: 'group-hover:border-green-200',
  },
  {
    title: 'Quán ốc - ăn vặt',
    // desc: 'Quản lý thu chi chặt chẽ, thống kê chính xác kết quả kinh doanh',
    desc: 'Với một thiết bị nhỏ gọn, hệ thống bán hàng tối giản cho phép quản lý mọi hoạt động mượt mà mà không cần đầu tư vào thiết bị cồng kềnh, tối ưu hóa chi phí và hiệu quả kinh doanh.',
    icon: <Hamburger size={32} weight="duotone" />,
    url: '/',
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-600',
    borderColor: 'group-hover:border-blue-200',
  },
  {
    title: 'Quán cà phê - trà sữa',
    // desc: 'Mọi thứ được gói gọn trong chiếc điện thoại thông minh của bạn',
    desc: 'Hệ thống thanh toán nhanh và trang bán hàng miễn phí xử lý đơn hàng chỉ trong vài giây, đảm bảo tốc độ phục vụ tối ưu cùng tính năng giảm giá trực tiếp trên hoá đơn được thực hiện nhanh chóng và chính xác.',
    icon: <Champagne size={32} weight="duotone" />,
    url: '/',
    bgColor: 'bg-violet-50',
    textColor: 'text-violet-600',
    borderColor: 'group-hover:border-violet-200',
  },
  // {
  //   title: 'Quán Cà phê',
  //   desc: 'Mọi thứ được gói gọn trong chiếc điện thoại thông minh của bạn',
  //   icon: <Coffee size={32} weight="regular" />,
  //   url: '/',
  // },
  {
    title: 'Quán bán mang đi',
    // desc: 'Trang bán hàng miễn phí giúp khách hàng dễ dàng đặt đơn ngay tại nhà',
    desc: 'Trang bán hàng miễn phí cùng tính năng đồng bộ đơn hàng online – offline giúp tối ưu hóa quy trình, tiết kiệm chi phí và thời gian, đảm bảo quá trình vận hành diễn ra suôn sẻ.',
    icon: <Popcorn size={32} weight="duotone" />,
    url: '/',
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-600',
    borderColor: 'group-hover:border-orange-200',
  },
  // {
  //   title: 'Nhà hàng truyền thống',
  //   desc: 'Từ các mô hình vừa và nhỏ như quán ăn, quán cà phê, cho đến các mô hình lớn như nhà hàng, buffet, chuỗi FnB',
  //   icon: <CookingPot size={32} weight="regular" />,
  //   url: '/',
  // },
  // {
  //   title: 'Nhà hàng Buffet',
  //   desc: 'QR gọi món tiện lợi, đưa trải nghiệm khách hàng lên tầng cao mới',
  //   icon: <Shrimp size={32} weight="regular" />,
  //   url: '/',
  // },
  {
    title: 'Chuỗi nhà hàng F&B',
    // desc: 'Quản lý đồng thời nhiều cửa hàng và kiểm soát kinh doanh tốt hơn',
    desc: 'Với một nền tảng duy nhất, một thiết bị và một tài khoản, chủ hệ thống có thể quản lý không giới hạn số chi nhánh từ xa, theo dõi hoạt động từng cửa hàng hiệu quả và kịp thời, mọi lúc mọi nơi.',
    icon: <IntersectThree size={32} weight="duotone" />,
    url: '/',
    bgColor: 'bg-cyan-50',
    textColor: 'text-cyan-600',
    borderColor: 'group-hover:border-cyan-200',
  },
];

export const SolutionSection = () => {
  return (
    <section
      id="solutions"
      className="section section-container relative overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        <Title
          title="Zump - Tiết kiệm, tinh gọn, dễ dùng"
          desc="Giải pháp đột phá, tối ưu toàn diện - chinh phục mọi mô hình kinh doanh F&B"
        />
      </motion.div>

      <div className="mx-auto mt-16 grid grid-cols-2 gap-4 sm:grid-cols-2 md:gap-8 md:px-20 lg:grid-cols-3 xl:gap-10">
        {businessTypes.map((business, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{
              duration: 0.5,
              delay: i * 0.1,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <Link
              href="/#download"
              className={`button-shinny group flex h-full flex-col justify-between gap-5 overflow-hidden rounded-2xl border bg-white/90 p-6 shadow-md shadow-primary-100/20 backdrop-blur-sm transition-all duration-300 hover:border-primary-200 hover:bg-white hover:shadow-xl hover:shadow-primary-100/20 ${business.borderColor}`}
            >
              <div className="flex grow flex-col gap-4">
                <div
                  className={`mx-auto flex size-16 items-center justify-center rounded-xl bg-none md:mx-0 ${business.bgColor} ${business.textColor} p-4 transition-all duration-300 group-hover:scale-110 group-hover:shadow-md`}
                >
                  {business.icon}
                </div>
                <div className="space-y-2">
                  <h3 className="text-lg font-semibold text-primary-900 max-sm:text-base md:text-left">
                    {business.title}
                  </h3>
                  <p className="hidden md:block md:text-left">
                    {business.desc}
                  </p>
                </div>
              </div>
              <motion.div
                className={`mt-2 hidden items-center gap-2 text-sm font-medium md:flex ${business.textColor}`}
                initial={{ x: -5, opacity: 1 }}
                whileHover={{ x: 0, opacity: 1 }}
                transition={{ type: 'spring', stiffness: 400, damping: 10 }}
              >
                <span className="text-primary-500">Tìm hiểu thêm</span>
                <ArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
              </motion.div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
